import { useEffect } from 'react';
import { abortableFetch } from '@eas/common-web';

/**
 * Calls /api/zsd/me every [interval] seconds, to keep the user logged in.
 *
 * @param [interval=600] @default 600 - The interval at which to send the request, in seconds.
 *
 */
export function useKeepAlive(interval = 600) {
  useEffect(() => {
    const _interval = setInterval(
      () =>
        abortableFetch('/api/zsd/me', {
          headers: {
            'Content-Type': 'application/json',
          },
        }),
      interval * 1000
    );
    return () => {
      clearInterval(_interval);
    };
  }, [interval]);
}
